import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private titleService: Title) { }

  ngOnInit() {
    if (environment.nordfab()) {
      this.titleService.setTitle('Nordfab User Management');
    } else {
      this.titleService.setTitle('Nederman User Management');
    }
  }
}
